import { fetchProviderProducts } from "@/api/providerDashboard";
import productsLifecycle from "@/controllers/productsLifecycle";
import productsPaginationMethods from "@/controllers/productsPaginationMethods";
import productPicksMethods from "@/controllers/productPicksMethods";

export default {
  data() {
    return {
      products: [],
      total: 0,
      page: 1,
      loading: true,
      productPicks: [],
      picksLoading: true,
      picksSaving: false,
      picksError: false,
    };
  },
  ...productsLifecycle,
  methods: {
    ...productPicksMethods,
    ...productsPaginationMethods,
    async fetchProducts() {
      this.loading = true;
      try {
        const res = await fetchProviderProducts({ page: this.page, limit: 20 });
        if (res.data.status === 200) {
          this.products = res.data.data || [];
          this.total = res.data.total || 0;
        }
      } catch (err) {
        this.$message.error("상품 목록을 불러올 수 없습니다.");
      } finally {
        this.loading = false;
      }
    },
    goToEdit(row) {
      this.$router.push(`/products/${row._id}`);
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("ko-KR");
    },
    formatPreferenceWeights(product) {
      const preferences = Array.isArray(product.preferences)
        ? product.preferences
        : [];
      const weights = product.preferenceWeights || {};

      return (
        preferences
          .map(
            (preference) =>
              `${preference} ${Number(weights[preference]) || 3}점`
          )
          .join(", ") || "-"
      );
    },
  },
};
